import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import { getRoles } from '../../data/mockData';
import ImagePicker from '../registration/ImageUploader';
import TextInput from '../InputComponent/TextInput';
import SelectInput from '../InputComponent/SelectInput';
import api from '../../services/ApiService';
import { ENDPOINTS } from '../../constant/ApiEndpoints';
const rolelist = [
    { id: 1, name: 'Admin', description: 'Has all access.' },
    { id: 4, name: 'Receptionist', description: 'Manages members and basic check-ins.' },
    { id: 2, name: 'Trainer', description: 'Views assigned members and their progress.' },
    { id: 3, name: 'Member', description: 'Basic app access.' },
];
const UserFormModal = ({ isOpen, onClose, onSave, user, isLoading }) => {
    const [roles, setRoles] = useState([]);
    useEffect(() => {
        setRoles(rolelist);
        // getAllRoles();
    }, []);
    console.log("userdetails", user);

    const getAllRoles = async () => {
        try {
            let response = await api.get(ENDPOINTS.getRoles);
            let result = response?.data;
            console.log(response);

        } catch (error) {
            console.log("getRoles error", error);
        }
    }
    const [preview, setPreview] = useState(null);
    const [base64Img, setBase64Img] = useState(null);
    const [file, setFile] = useState(null);

    const handleImageSelect = (e) => {
        const selected = e.target.files[0];
        if (!selected) return;

        // ✅ Only JPG allowed
        if (!["image/jpg", "image/jpeg"].includes(selected.type)) {
            alert("Only JPG images are allowed.");
            return;
        }

        // ✅ Create preview
        setPreview(URL.createObjectURL(selected));

        // ✅ Compress Image
        const reader = new FileReader();
        reader.readAsDataURL(selected);

        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const MAX_WIDTH = 600;   // ✅ desired output width
                const MAX_HEIGHT = 600;  // ✅ maintain ratio

                let width = img.width;
                let height = img.height;

                // ✅ Resize while maintaining aspect ratio
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }

                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                // ✅ Compress to 70% JPG
                const compressedBase64 = canvas.toDataURL("image/jpeg", 0.7);

                setBase64Img(compressedBase64);

                console.log("Compressed Size (KB):", Math.round((compressedBase64.length * 3) / 4 / 1024));
            };
        };
    };


    const [formData, setFormData] = useState({
        id: '',
        name: '',
        email: '',
        phone: '',
        role: '',
        status: 'active',
        image_base64: "",
    });

    useEffect(() => {
        if (user) {
            setFormData({
                id: user.id || '',
                name: user.name || '',
                email: user.email || '',
                phone: user.phone || '',
                role: user.role?.id || '',
                status: user.status || 'active',
                meta: user.meta ?? {},
                image_base64: user.image_base64,
            });
        } else {
            setFormData({
                id: '',
                name: '',
                email: '',
                phone: '',
                role: '',
                status: 'active',
                meta: {}
            });
        }
    }, [user, isOpen, roles]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.name || !formData.email) {
            toast.error('Name and Email are required.');
            return;
        }
        if (formData.phone.length < 7) {
            toast.error('Please enter at least 7 digit mobile number');
            return;
        }
        if (formData.phone.length > 11) {
            toast.error('Mobile number cannot exceed 11 digits');
            return;
        }
        onSave({ ...formData });
    };

    const isEditing = !!user;

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={isEditing ? 'Edit User' : 'Add New User'}>
            <form onSubmit={handleSubmit} className="space-y-4">
                <ImagePicker preview={preview} onSelect={handleImageSelect} />
                <TextInput label={"Full Name"} type="text" name="name" value={formData.name} onChange={handleChange} isRequired={true} />
                <TextInput label={"Email"} type="email" name="email" value={formData.email} onChange={handleChange} isRequired={true} />
                <TextInput label={"Phone"} type="number" name="phone" value={formData.phone} onChange={handleChange} isRequired={true} />

                <div className="grid grid-cols-2 gap-4">
                    {!isEditing && <SelectInput disabled={isEditing} label={"Role"} name="role" value={formData.role} onChange={handleChange} isRequired={true}>
                        <option>Select Role {isEditing}</option>
                        {roles.map(role => (
                            <option key={role.id} value={role.id}>{role.name}</option>
                        ))}
                    </SelectInput>}
                    <SelectInput label={"Status"} name="status" value={formData.status} onChange={handleChange} >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </SelectInput>
                </div>
                <div className="pt-4 flex justify-end gap-3">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Cancel</button>
                    <button disabled={isLoading} type="submit" className="px-4 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600">{isLoading ? 'Loading...' : 'Save & Close'}</button>
                </div>
            </form>
        </Modal>
    );
};

export default UserFormModal;
